import axios from "axios";

const APIURL = process.env.REACT_APP_API_URL; 

const axiosCall = axios.create({
  baseURL: APIURL,
  headers: {
    "Content-type": "application/json",
  },
});

// Add a request interceptor
axiosCall.interceptors.request.use(
  function (response) {
    return response;
  },
  function (error) {
    return Promise.reject(error);
  }
);

// Add a response interceptor
axiosCall.interceptors.request.use(
  function (config) {
    config.withCredentials = true;
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

export default axiosCall;
